/**
 * promptHistory — tiny localStorage-backed FIFO of the last 5 Lumière goals.
 * Kept as a plain module (not a store) since it's synchronous & rarely
 * changes. Consumers can subscribe via the returned snapshot.
 */
const KEY = 'lumiere:prompt-history';
const MAX = 5;

const read = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr.slice(0, MAX) : [];
  } catch {
    return [];
  }
};

const write = (list) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch { /* quota / disabled — ignore */ }
};

export const promptHistory = {
  list: () => read(),

  push: (goal) => {
    const clean = (goal || '').trim();
    if (clean.length < 3) return;
    const current = read().filter((g) => g !== clean);
    const next = [clean, ...current].slice(0, MAX);
    write(next);
  },

  remove: (goal) => {
    const next = read().filter((g) => g !== goal);
    write(next);
  },

  clear: () => write([]),
};

export default promptHistory;
